module.exports = __webpack_public_path__ + "img/vdo_11.44c5688b.jpg";